import ReactDOMServer from 'react-dom/server';
import { _, React, Component, PropTypes, Container } from 'utils';
import { ActiveStore, Store, Creators } from 'model';
import Suggestions from './suggestions/component';
import Icon from './Icon';
import './search.less';
import Tag from './Tag';
import { Popover } from '../components';


class BaseSearch extends Component {

	constructor(props)
	{
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleArrows = this.handleArrows.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		//this.handleSearchHelpClick = this.handleSearchHelpClick.bind(this);
	}

	static propTypes = {
		description: PropTypes.string
	}

	componentDidMount() {
		$(this.searchHelpPopover).popover();
	}

	handleArrows(event) {
		var { store, filter, visible } = this.state;

		if(event.key === 'ArrowUp') {
			event.preventDefault();
			this.state.onPrevious({ store: store });
		} else if(event.key === 'ArrowDown') {
			event.preventDefault();
			this.state.onNext({ store: store });
		} else if(visible === true && event.key === 'Escape') {
			Creators.hideRecommendations({ store: store });
		} else if(visible === false && event.key === 'Escape') {
			Creators.clearFilters();
		} else if(filter === null && (event.key === 'Enter' || event.key === 'Tab')) {
			event.preventDefault();
			this.state.onSelect({ store: store });
		} else if(filter !== null && event.key === ' ' || (event.key === 'Enter' || event.key === 'Tab')) {
			event.preventDefault();
			Creators.addFilter(filter);
		}
	}
	
	handleSelect(item) {
		var { store } = this.state;
		Creators.selectSuggestion({ store: store, item: item });
	}

	handleChange() {
		var query = $(this.input).val();
		var { store } = this.state;

		this.state.onFind({ store: store, query: query });
	}

	handleBlur(event) {
		var { onBlur, store } = this.state;
		var { relatedTarget } = event;

		if(!$.contains(this.box, relatedTarget)) {
			onBlur({ store: store });
		}
	}

	handleSearch() {
		event.preventDefault();
		var { filter, store, visible, onSelect } = this.state;

		if(visible === true && filter === null) {
			onSelect({store: store});
		} else if(filter !== null) {
			Creators.addFilter(filter);
		}else if(this.state.query !=''){
            onSelect({store: store});
        }
	}

	showFilters = () => {
		Creators.showFilters();
	}

	renderSuggestions() {
		return <Suggestions onSelect={ this.handleSelect } />;
	}

	render() {

		var data = this.state;
		var { store, visible } = this.state;

		var search = _('Traži');
		var placeholder = _(data.description);

		if(data.mode !== 'search') {
			placeholder = _(data.filterDescription);
		}

		if(visible) {
			search = 'Dodaj';
		} else if (data.mode !== 'search') {
			search = 'Dodaj';
		}

		var type = data.mode;

		if(data.type !== 'search') {
			type = data.type;

			if(!data.visible) {
				search = "Dodaj";
			}
		}

		const FilterTags = this.state.filters
			.filter(filter => (store == 'any' || filter.src == store))
			.map((filter, index) => (
				<Tag 
					key={index}
					data={filter}
					onClick={Creators.removeFilter}
				/>
			));

		const PopoverTemplate = (
			<div className="popover search-popover" role="tooltip">
				<div className="arrow"></div>
				<h3 className="popover-title"></h3>
				<div className="popover-content"></div>
			</div>
		);

		const PopoverContent = (
			<ul>
				<li>{_("help_search_popover_bullet_1", "npr. Zagreb, engleski, VSS, određeno")}</li>
			</ul>
		);

		return <div ref={(box) => { this.box = box; }}>
			<div className="dropdown search-box">
				<div className="controls">
					<span className="search-type">
						<Icon type={type} />
					</span>
					<input 
						type="text"
						className="form-control search-control"
						ref={(input) => {this.input = input;}}
						value={ data.query }
						placeholder={ placeholder }
						onKeyDown={this.handleArrows}
						onChange={this.handleChange}
						onBlur={this.handleBlur}
					/>
					<Popover
						className="search-help"
						triggerComponent={<Icon type="question" />}
						title={_("Upišite ključne pojmove")}
						content={PopoverContent}
						template={PopoverTemplate}
						placement="bottom"
						html
					/>
					<input type="button" className="btn btn-primary" onClick={this.handleSearch} value={search} />
					<button className="btn btn-default" onClick={this.showFilters}>
						<i className="fa fa-sliders"></i>
					</button>
				</div>
				{ this.renderSuggestions() }
			</div>
			<div className="active-filters">{ FilterTags }</div>
		</div>
	}
}

class Search extends BaseSearch {
	static getStores() {
		return [ActiveStore, Store];
	}

	static calculateState(state, props) {
		var state = Store.getState();

		return {
			query: Store.getQuery(),
			filter: state.selected,
			visible: state.visible,
			filters: ActiveStore.getState().filters,
			type: state.type,
			description: props.description,
			onFind: Creators.queryChanged,
			onNext: Creators.nextSuggestion,
			onPrevious: Creators.previousSuggestion,
			onSelect: Creators.selectSuggestion,
			onBlur: Creators.blur,
			mode: ActiveStore.getState().filters.length == 0?'search':'add',
			store: props.store,
			filterDescription: props.filterDescription
		}
	}
}

export { BaseSearch };
export default Container.create(Search, {withProps: true});


// WEBPACK FOOTER //
// ./src/modules/app/search/Search.js